import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-instruction',
  templateUrl: './instruction.component.html',
  styleUrls: ['./instruction.component.scss']
})
export class InstructionComponent implements OnInit {

  instructions: string;

  constructor(
    public dialogRef: MatDialogRef<InstructionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    if (this.data && this.data.length > 0) {
      this.instructions = this.data.join('\n');
    }
  }

  saveInstructions(): void {
    if (this.instructions) {
      const a: string[] = [];
      for (const item of this.instructions.split('\n')) {
        if (item.length > 0) {
          a.push(item);
        }
      }
      if (a.length > 0) {
        this.dialogRef.close(a);
        return;
      }
    }
    this.dialogRef.close(null);
  }

}
